import React from "react"
import classes from "./Loader.module.css"

const loader = () => <div className={classes.Loader}>Loading..!</div>

export default loader
